module.exports = __webpack_public_path__ + "img/audio-mark12.9f2f08a2.png";